<template>
  <div class="container">
    <div style="text-align: right;">
      <van-image width="100%" :src="require('@/assets/zyz-wen@2x.png')" />
    </div>
    <div class="list">
      <h4 v-if="reviewImg == null">山西博物院志愿者招募</h4>
<!--      <template v-for="item of list">-->
        <router-link v-if="reviewImg !== null" :to="{ path: '/volunteer/signUp'}" tag="section">
          <h4>{{ reviewImg.name }}</h4>
          <van-image class="img" width="100%" fit="cover" :src="reviewImg.coverImage" />
          <div class="Divider"><img src="@/assets/jyhd-biao1@3x.png" alt=""></div>
        </router-link>
<!--      </template>-->
      <van-empty
        v-if="reviewImg == null"
        class="custom-image"
        :image="require('@/assets/moren@2x.png')"
        description="活动尚未开始，敬请期待"
      />
    </div>
    <router-link tag="section" class="review" to="/volunteer/review">
      <h4>活动回顾</h4>
      <van-image class="img" width="100%" fit="cover" :src="require('@/assets/bottomImg.jpg')" />
    </router-link>
  </div>
</template>

<script>
import { getSignList, getRequestNotice } from '@/api/volunteer'

export default {
  name: 'VolunteerIndex',
  data: () => ({
    list: [],
    reviewImg: ''
  }),
  created () {
    this.getList()
    this.getReviewImg()
  },
  methods: {
    async getList () {
      const { result } = await getSignList()
      console.log(result)
      this.list = result
    },
    async getReviewImg () {
      const { result } = await getRequestNotice()
      this.reviewImg = result
    }
  }
}
</script>

<style lang="scss" scoped>
.Divider {
  margin-top: 18px;
  margin-bottom: 11px;
  img {
    width: 100%;
  }
}
.container {
  position: relative;
  min-height: 100vh;
  background-color: #EEEDEC;
  overflow: hidden;
  ::v-deep .custom-image .van-empty__image {
    height: auto;
    text-align: center;
    img {
      width: 70%;
      height: auto;
    }
  }
  .img {
    height: 183px;
  }
  .bg-text {
    width: 120px;
    position: absolute;
    top: 190px;
    left: 20px;
  }
  .bg-pattern {
    position: absolute;
    top: 255px;
    right: 0;
    width: 173px;
  }
  .list {
    margin: 20px 20px 0px;
    >h4 {
      color: #392f29;
      font-size: 18px;
      margin: 6px 0 13px;
      font-family: 'xique';
    }
  }
  section {
    overflow: hidden;
    &.review {
      margin: 0 20px 20px;
    }
    h4 {
      color: #392f29;
      font-size: 18px;
      margin: 6px 0 13px;
      font-family: 'xique';
    }
    .van-image {
      border-radius: 8px;
      overflow: hidden;
    }
  }
}
</style>
